module.exports = __webpack_public_path__ + "static/img/couponBg.968563c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/couponBg.png
// module id = EK4U
// module chunks = 13